<template>
  <layout-default>
    <div class="policy-page container">
      <header class="policy-header">
        <h1>Cookie Policy</h1>
        <p>
          This page describes the cookies and similar technologies we use, why we use them, and how you can
          control your preferences.
        </p>
      </header>

      <section class="policy-section">
        <h2>What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device to remember preferences, keep you signed in, and help
          us understand how the site is used. We use both session cookies (removed when you close the browser) and
          persistent cookies (which remain until they expire or are deleted).
        </p>
      </section>

      <section class="policy-section">
        <h2>Types of Cookies We Use</h2>
        <p>
          Essential cookies keep core features running, like secure checkout and account access. Analytics cookies
          help us measure performance and improve the experience. Marketing cookies personalize content and may be
          set by trusted partners to show relevant offers.
        </p>
      </section>

      <section class="policy-section">
        <h2>Managing Cookies</h2>
        <p>
          You can change cookie settings in your browser at any time. Disabling essential cookies may impact the
          ability to log in or complete orders, while opting out of analytics or marketing cookies will not block
          your access to core services.
        </p>
      </section>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";

export default {
  name: "CookiePolicy",
  components: { LayoutDefault },
  created() {
    document.title = "Cookie Policy - viabrera";
  },
};
</script>

<style scoped>
.policy-page {
  padding: 60px 0 120px;
  color: #1f1f1f;
}

.policy-header {
  margin-bottom: 40px;
  text-align: left;
}

.policy-header h1 {
  font-size: clamp(2rem, 4vw, 2.8rem);
  margin-bottom: 12px;
}

.policy-header p {
  max-width: 720px;
  margin: 0;
  color: #5b5b5b;
  line-height: 1.6;
}

.policy-section + .policy-section {
  margin-top: 32px;
}

.policy-section h2 {
  font-size: 1.5rem;
  margin-bottom: 12px;
}

.policy-section p {
  margin: 0;
  line-height: 1.7;
  color: #3c3c3c;
}
</style>
